// File upload widget — uploads image via /api/admin/upload and returns URL
import { useRef, useState } from "react";
import { api, API } from "@/lib/api";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export default function FileUpload({ value, onChange, label = "Imagem", testid = "image-upload" }) {
    const ref = useRef(null);
    const [busy, setBusy] = useState(false);

    const upload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setBusy(true);
        const fd = new FormData();
        fd.append("file", file);
        try {
            const { data } = await api.post("/admin/upload", fd, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            const fullUrl = `${API.replace(/\/api$/, "")}${data.url}`;
            onChange(fullUrl);
            toast.success("Imagem carregada");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Erro no upload");
        } finally {
            setBusy(false);
            e.target.value = "";
        }
    };

    return (
        <div data-testid={testid}>
            {label && <span className="label-mono mb-2 block">{label}</span>}
            <div className="flex items-start gap-3">
                {value && (
                    <div className="relative w-24 h-24 border-2 border-ink bg-muted overflow-hidden shrink-0">
                        <img src={value} alt="preview" className="w-full h-full object-cover" />
                        <button
                            type="button"
                            onClick={() => onChange("")}
                            className="absolute top-1 right-1 bg-ink text-white p-1 hover:bg-magenta"
                        >
                            <X size={12} />
                        </button>
                    </div>
                )}
                <div className="flex-1">
                    <input ref={ref} type="file" accept="image/*" onChange={upload} className="hidden" />
                    <button
                        type="button"
                        onClick={() => ref.current?.click()}
                        disabled={busy}
                        className="btn-secondary disabled:opacity-50"
                    >
                        {busy ? <Loader2 className="animate-spin" size={14} /> : <Upload size={14} />}
                        {busy ? "A carregar…" : value ? "Substituir" : "Carregar imagem"}
                    </button>
                    <input
                        type="text"
                        value={value || ""}
                        onChange={(e) => onChange(e.target.value)}
                        placeholder="Ou colar URL externo…"
                        className="input-edge mt-2 text-xs"
                    />
                </div>
            </div>
        </div>
    );
}
